import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import axios from "../../plugins/axios";

const useAccountLocations = (accountId) =>
    useQuery([queryKeys.accountLocations, accountId], async () => {
        let response = await axios.get(`${process.env.REACT_APP_CASENEST_API_URL}/getaccountlocations/${accountId}`);
        return response.data;
    }, {
        enabled: !!accountId,
        staleTime: 600000,
        cacheTime: 900000
    });

export default useAccountLocations;
